/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import {
  ConsultItem,
  getSteadyConsultDetails,
} from "@modules/consults/getSteadyConsultDetails";
import { isSteadyPatient } from "common/utils";

import { SteadyConsultType, SteadyConsultStatus } from "../common/types";

import { useAuthCredentials } from "./useAuthCredentials";
import { usePatient } from "./usePatient";

/*
 * React hook to fetch consults for a patient
 * */
export const useSteadyConsults = ({
  startFromDate,
  endByDate,
  consultStatusFilters,
  consultTypeFilters,
}: {
  startFromDate?: string;
  endByDate?: string;
  consultStatusFilters?: SteadyConsultStatus[];
  consultTypeFilters?: SteadyConsultType[];
}): ConsultItem[] | null | undefined => {
  const patient = usePatient();
  const { accessToken } = useAuthCredentials();
  const [consultsList, setConsultsList] = useState<ConsultItem[] | null>();

  useEffect(() => {
    if (!patient || !isSteadyPatient(patient)) return;
    const getAndSetConsultsList = async () => {
      getSteadyConsultDetails({
        authToken: accessToken ?? "",
        userId: patient.user_id,
        startFromDate,
        endByDate,
        consultStatusFilters,
        consultTypeFilters,
      })
        .then((consultsListResponse) => {
          setConsultsList(consultsListResponse.data.consults);
        })
        .catch(() => {
          setConsultsList(null);
        });
    };
    getAndSetConsultsList();
    // `patient?.user_id` is included so the fetch re-runs once the patient
    // profile resolves (access token alone is available before the profile).
  }, [patient?.user_id, accessToken, startFromDate, endByDate]);

  return consultsList;
};
